export default "__VITE_ASSET__9add6620__"